<template>
  <div class="shade" v-show="quit"  >
    <div class="shadeBox">
      <div id="brokenline"></div>
      <div class="image" @click="closeMark()">
        <img src="@/assets/img/12.png" alt />
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import echarts from "echarts";
export default {
  props: {},
  components: {},
  data() {
    return {
      quit: true, //遮罩 
    };
  },
  computed: {},
  methods: {
    //   关闭
    closeMark() {
      this.quit = !this.quit;
    },
    a() {
      var myChart = echarts.init(document.getElementById("brokenline"));
      // console.log(myChart)

      // 指定图表的配置项和数据
      var option = {
        title: {
          text: "平均持股数(股)", // 标题栏
          left: 10,
          textStyle: {
            fontSize: 15,
            backgroundColor: "#DFDFDF",
            color: "#333" //标题颜色
          }
        },
        legend: {
          // 图例组件
          orient: "horizontal", // 图例列表的布局朝向
          //   right: 1, // 图例组件离容器右侧的距离
          top: 40,
          textStyle: {
            color: "#333", // 字体颜色
            fontWeight: "normal",
            fontSize: 14
          },
          data: ["平均持股数（股）"] // 和series 中的name对应
        },
        xAxis: {
          type: "category",
          //   data: ["Mon", "Tue", "Wed"],
          boundaryGap: ["20%", "20%"],
          axisTick: {
            //刻度朝向
            inside: true
          },
          //  axisLabel :{ //刻度字体
          //      inside:true
          //  }
          axisLabel: {
            show: true,
            textStyle: {
              color: "#4D4D4D" // 坐标字体颜色
            }
          },
          axisLine: {
            lineStyle: {
              color: "#BABABA" // x坐标轴颜色
            }
          }
        },
        yAxis: {
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#4D4D4D" // 坐标字体颜色
            }
          },
          axisLine: {
            lineStyle: {
              color: "#BABABA" // x坐标轴颜色
            }
          }
        },
        series: [
          {
            name: "平均持股数（股）",
            // data: [820, 932, 901],
            type: "line",
            smooth: true,
            connectNulls: true,   //这个是重点，将断点连接
            itemStyle: {
              normal: {
                label: { show: false},
                color: "#0F71C8",
                lineStyle: { color: "#0F71C8" }
              }
            }
          }
        ]
      };

      myChart.setOption(option);
      let stockCode = JSON.parse(sessionStorage.getItem("stockCode"));
      let enterpriseCode = JSON.parse(sessionStorage.getItem("enterpriseCode"));
      let endDate = JSON.parse(sessionStorage.getItem("endDate"));
      let closeDate = [];
      let averageNum = [];
      //   let averageNum = [];
      api.stockMajorBalance(stockCode, enterpriseCode, endDate).then(res => {
        let result = res.data;
        for (var i = result.length - 1; i >= 0; i--) {
          closeDate.push(result[i].closeDate);
          averageNum.push(result[i].averageNum);
          //   averageNum.push(result[i].averageNum);
        }
        myChart.setOption({
          xAxis: {
            //给x轴赋值
            data: closeDate
          },
          series: [
            {
              //y轴
              data: averageNum
            }
          ]
        });
      });
    }
  },
  created() {},
  mounted() {
    this.a();
  }
};
</script>
<style scoped lang="less">
.shade {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  .shadeBox {
    width: 895px;
    height: 520px;
    line-height: 100px;
    // background: lightcoral;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: relative;
    #brokenline {
      width: 895px;
      height: 520px;
      background: #fff;
      padding-top: 10px;
    }
    .image {
      position: absolute;
      // background: lawngreen;
      width: 12px;
      height: 12px;
      top: 0;
      right: 0;
      margin-right: 20px;
      margin-top: 11px;
      cursor: pointer;
    }
    img {
      position: absolute;
      width: 12px;
      height: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/balance.vue